export type NotificationRequestMessages = {
  removeNotificationSuccess: string;
  removeNotificationError: string;
  markNotificationAsReadSuccess: string;
  markNotificationAsReadError: string;
  markAllNotificationsAsReadSuccess: string;
  markAllNotificationsAsReadError: string;
  markSingleNotificationAsReadSuccess: string;
  markSingleNotificationAsReadError: string;
};

export const NOTIFICATION_REQUEST_MESSAGES: NotificationRequestMessages = {
  removeNotificationSuccess: "Notificação removida com sucesso!",
  removeNotificationError: "Erro ao remover a notificação!",
  markNotificationAsReadSuccess: "Notificação marcada como lida com sucesso!",
  markNotificationAsReadError: "Erro ao marcar a notificação como lida!",
  markAllNotificationsAsReadSuccess: "Todas as notificações foram marcadas como lidas!",
  markAllNotificationsAsReadError: "Erro ao marcar todas as notificações como lidas!",
  markSingleNotificationAsReadSuccess: "Notificação foi marcada como lida!",
  markSingleNotificationAsReadError: "Erro ao marcar a notificação como lida!",
};

export default NOTIFICATION_REQUEST_MESSAGES;
